import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { ComumModule } from '../../../shared/comum.module';
import { SeminovosFiltroComponent } from './seminovos-filtro/seminovos-filtro.component';
import { SeminovosListaComponent } from './seminovos-lista/seminovos-lista.component';
import { SeminovosService } from './seminovos-services/seminovos.service';
import { SeminovosComponent } from './seminovos.component';


@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    ButtonModule,
    DialogModule,
    DropdownModule,
    TooltipModule,
    InputTextModule,
    NgbModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    SeminovosComponent
  ],
  declarations: [
    SeminovosComponent,
    SeminovosListaComponent,
    SeminovosFiltroComponent
  ],
providers: [
  SeminovosService 
]
})
export class SeminovosModule { }
